module.exports = __webpack_public_path__ + "static/media/collage_GLP_positive.828dafc1.jpg";